export default __webpack_public_path__ + "static/media/Comau.c854e9c0.png";